import {
  TenantPageAccessCodeRequest,
  TenantPageAccessCodeResponse,
  TenantPageHomeResponse,
  TenantPageIssueLinkResponse,
  TenantPagePaymentLinkRequest,
  TenantPagePaymentLinkResponse,
  TenantPageRedeemLinkRequest,
  TenantPageRedeemLinkResponse,
  TenantPageRequestCodeRequest,
  TenantPageRequestCodeResponse,
  TenantPageSessionRequest,
  TenantPageVerifyCodeRequest,
  TenantPageVerifyCodeResponse
} from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

/**
 * Spot tenant page (ENG-3545). The public calls are made by the tenant's browser; `issueLink`
 * is internal (bot and sequence engine).
 */
export class TenantPageAPI {
  static async redeemLink(body: TenantPageRedeemLinkRequest) {
    return APIService.Server.post<TenantPageRedeemLinkResponse>(`/tenant-page/link/redeem`, body);
  }

  static async requestCode(body: TenantPageRequestCodeRequest) {
    return APIService.Server.post<TenantPageRequestCodeResponse>(`/tenant-page/code/request`, body);
  }

  static async verifyCode(body: TenantPageVerifyCodeRequest) {
    return APIService.Server.post<TenantPageVerifyCodeResponse>(`/tenant-page/code/verify`, body);
  }

  static async home(brandSlug: string, session: string) {
    return APIService.Server.get<TenantPageHomeResponse>(
      `/tenant-page/home?brandSlug=${encodeURIComponent(brandSlug)}&session=${encodeURIComponent(session)}`
    );
  }

  static async refresh(body: TenantPageSessionRequest) {
    return APIService.Server.post<TenantPageHomeResponse>(`/tenant-page/refresh`, body);
  }

  static async paymentLink(body: TenantPagePaymentLinkRequest) {
    return APIService.Server.post<TenantPagePaymentLinkResponse>(`/tenant-page/payment-link`, body);
  }

  /** POST so the code stays out of URLs and logs. */
  static async accessCode(body: TenantPageAccessCodeRequest) {
    return APIService.Server.post<TenantPageAccessCodeResponse>(`/tenant-page/access-code`, body);
  }

  /** Internal: the 6-hour link that goes in a text. `ok: false` names the switch that is off; callers fall through to the portal. */
  static async issueLink(orgId: number, userId: number, locationId?: number) {
    const query = locationId !== undefined ? `?locationId=${locationId}` : "";
    return APIService.Server.post<TenantPageIssueLinkResponse>(`/tenant-page/org/${orgId}/user/${userId}/link${query}`, {});
  }
}
